import {
  IGenericRequestParametersTranslator,
  INamedEntityLabels,
  IPaginationParametersTranslator,
  PropertyTranslator,
} from "./GenericTranslator";
import {
  GenericEntityOrderBy,
  EntityConstants,
  IEntityMinimalModel,
  IGenericRequestParameters,
  IModelWithStringId,
  INamedEntity,
  IPaginationParameters,
  NamedEntityOrderBy,
} from "./GenericTypes";

export const dataFormatInstrumentsConstants: EntityConstants<DataFormatInstrument, DataFormatInstrumentFilters> = {
  resource: "data_format_instruments",
  frontendIndexRoute: "formats",
  entitySingular: "instrument",
  entityPlural: "instruments",
  icon: "package",
};

export interface DataFormatInstrument extends IModelWithStringId, INamedEntity {
  description: string;
}
export const ParserInstrumentFieldLabels: PropertyTranslator<DataFormatInstrument> = {
  ...INamedEntityLabels,
  description: "Description",
  id: "Data format instrument ID",
} as const;

export interface DataFormatInstrumentSuggestions extends IEntityMinimalModel<DataFormatInstrument["id"]> {}

export interface DataFormatInstrumentFilters
  extends IGenericRequestParameters<DataFormatInstrument, DataFormatInstrumentSortingOptions>,
    IPaginationParameters {}

export const DataFormatInstrumentFiltersTranslator: PropertyTranslator<DataFormatInstrumentFilters> = {
  ...IGenericRequestParametersTranslator,
  ...IPaginationParametersTranslator,
} as const;

export const DataFormatInstrumentSortingOptionsConsts = [...GenericEntityOrderBy, ...NamedEntityOrderBy] as const;
export type DataFormatInstrumentSortingOptions = (typeof DataFormatInstrumentSortingOptionsConsts)[number];
